<template>
  <div class="input-modal-wrapper">
    <div class="input-modal">
      <form>
        <!-- INPUT -->
        <div v-if="isComingFromCompany">
          <label for="editInputField" class="input-label"></label>
          <div class="input-wrapper">
            <span class="miv">Z</span>
            <input
              id="editInputField"
              type="text"
              placeholder="Нова стойност"
              v-model="input"
            />
          </div>
        </div>

        <div class="inputs" :class="{ hide: this.isComingFromCompany }">
          <!-- INPUT MATERIAL  -->
          <div class="input-wrapper" v-if="isComingFromMaterials">
            <span class="miv">U</span>
            <input
              id="inputActivityField"
              type="text"
              placeholder="Материал"
              v-model="inputName"
            />
          </div>

          <!-- INPUT ACTIVITY  -->
          <div class="input-wrapper" v-if="isComingFromActivities">
            <span class="miv">U</span>
            <input
              id="inputActivityField"
              type="text"
              placeholder="Дейност"
              v-model="inputName"
            />
          </div>

          <!-- COMMON INPUTS -->
          <div
            class="input-wrapper"
            v-if="isComingFromMaterials || isComingFromActivities"
          >
            <span class="miv">Z</span>
            <input
              id="inputUnitField"
              type="text"
              placeholder="Мерна единица"
              v-model="inputUnit"
            />
          </div>
          <template
            v-if="
              getUser.permissions.isSuperAdmin || getUser.permissions.isAdmin
            "
          >
            <div
              class="input-wrapper"
              v-if="isComingFromMaterials || isComingFromActivities"
            >
              <span class="miv">Z</span>
              <input
                id="inputPriceField"
                type="number"
                min="0"
                placeholder="Цена"
                v-model="inputPrice"
              />
            </div>
          </template>
        </div>

        <div class="input-modal-actions">
          <div>
            <!-- JUST AND EMPTY DIV FOR THE SPACE-BETWEEN RULE TO WORK -->
          </div>
          <div class="btns">
            <button class="btn btn-close" @click.prevent="close()">
              <span class="miv">F</span>
              Отказ
            </button>
            <!-- BUTTON ACCEPT FOR COMPANY/PROJECT/OBJECT/PART-->
            <button
              v-if="isComingFromCompany"
              class="btn btn-new"
              type="submit"
              value="Submit"
              @click.prevent="save()"
            >
              <span class="miv">c</span>
              Редактирай
            </button>
            <!-- BUTTON ACCEPT FOR MATERIAL/ACTIVITY-->
            <button
              v-if="isComingFromActivities || isComingFromMaterials"
              class="btn btn-new"
              type="submit"
              value="Submit"
              @click.prevent="saveMaterialOrActivity()"
            >
              <span class="miv">Y</span>
              Запази
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['getUser']),
  },
  props: [
    'inputForEdit',
    'isComingFromActivities',
    'isComingFromMaterials',
    'isComingFromCompany',
  ],
  data() {
    return {
      input: '',
      inputName: undefined,
      inputUnit: undefined,
      inputPrice: 0,
    };
  },
  methods: {
    // SAVE METHODS
    save() {
      if (!this.input) {
        this.$snotify.error('Моля, въведедете стойност');
      } else {
        this.$parent.$emit('saveEditInputModal', {
          value: this.input,
          where: this.inputForEdit.where,
        });
        // this.$snotify.success("Успешно редактиране!");
      }
    },
    saveMaterialOrActivity() {
      if (this.inputValidatation()) {
        // Check for materials modal
        if (this.isComingFromMaterials) {
          this.$parent.$emit('saveMaterialOrActivity', {
            materialName: this.inputName,
            materialUnit: this.inputUnit,
            materialPrice: this.inputPrice,
            isAdditional: true,
            isSelected: true,
          });
          this.close();
        }
        // Check for activities modal
        else if (this.isComingFromActivities) {
          this.$parent.$emit('saveMaterialOrActivity', {
            activityName: this.inputName,
            activityUnit: this.inputUnit,
            activityPrice: this.inputPrice,
            isAdditional: true,
            isSelected: true,
          });
          this.close();
        }
      }
    },
    // VALIDATE INPUTS
    inputValidatation() {
      if (!this.inputName) {
        this.$snotify.error(
          `въведедете ${this.isComingFromActivities ? 'дейност' : 'материал'}`
        );
        return false;
      }
      if (!this.inputUnit) {
        this.$snotify.error('въведедете мерна единица');
        return false;
      }
      if (this.inputPrice === undefined) {
        this.$snotify.error('въведедете цена');
        return false;
      }
      if (this.inputName && this.inputUnit && this.inputPrice !== undefined) {
        return true;
      }
    },
    close() {
      this.$parent.$emit('closeEditInputModal');
    },
  },
  mounted() {
    if (this.isComingFromCompany) {
      this.input = this.inputForEdit.value;
    }
  },
};
</script>

<style scoped>
.input-modal-wrapper {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;
}
.input-modal {
  background-color: #fff;
  border-radius: 4px;
  border-top: 10px solid #083f75;
  display: flex;
  flex-direction: column;
  /* height: 60vh; */
  overflow: auto;
  padding: 10px 20px 0;
  /* width: 600px; */
}
.input-modal-permissions {
  background-color: #f4f4f4;
  border-radius: 4px;
  display: flex;
  justify-content: center;
}
.input-modal-actions {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}
.invalid .miv {
  color: #d91313;
}
.invalid input {
  background-color: #f8dcdc;
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.inputs {
  display: flex;
  margin-top: 20px;
}
.input-wrapper {
  margin-right: 1em;
  margin-bottom: 1em;
}
.btns .btn:first-child {
  margin-left: 0;
}
.input-wrapper:last-child {
  margin-right: 0px;
  /* margin-bottom: 0px; */
}
.hide {
  display: none;
}

/* Responsive */
@media screen and (max-width: 1000px) {
  .btn.btn-close {
    margin-bottom: 5px;
  }
}
@media screen and (max-width: 650px) {
  .input-modal {
    width: 90%;
  }
}
@media screen and (max-width: 450px) {
  .inputs {
    flex-direction: column;
  }
  .input-wrapper {
    margin-right: 0px;
  }
  .btns {
    display: flex;
    flex-direction: column;
  }
  .btn.btn-close {
    margin-bottom: 10px;
  }
}
</style>
